module.exports = __webpack_public_path__ + "img/logo_full@2x.3171fcf0.png";